module.exports = __webpack_public_path__ + "img/layers.cc4b7377.svg";